import React, {useEffect, useState} from "react";
// Use Forms
import {useForm} from "react-hook-form";
import {ErrorMessage} from "@hookform/error-message";
// React Bootstrap
import {Alert, Button, Col, Form} from "react-bootstrap";
// Search Select
import SearchSelectObserver from "../generic/MySearchSelectObserver";
// jquery
import $ from "jquery";
// Utils
import {addYears, dateToString2} from "../../utils";
// Components
import HorizontalCard from "../generic/HorizontalCard";
import TooltipIcon from "../generic/TooltipIcon";
// Styled
import styled from "styled-components";
// Contexto
import {cargosContext} from "../../contexto";

const CardUsuario = styled(HorizontalCard)`
  width: 100%;
`;

const FormCargo = ({ idEntidad, idSubEntidad, type, defaultValues, submissionHandler, cargoDisponible, handlerEndDate, noControl }) => {
  // Comprueba si estamos editando
  const estamosEditando = !!defaultValues?.userId;

  // Validación del formulario
  const [validated] = useState(false);
  // Métodos para use hook forms
  const methods = useForm({
    defaultValues: defaultValues,
  });
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  // Usuarios para el search select
  const [usuarios, setUsuarios] = useState([]);

  // Default value para el search select
  const [defaultUsuario, setDefaultUsuario] = useState({});

  // Controla el usuario por defecto y lo guarda
  useEffect(() => {
    if (estamosEditando) setDefaultUsuario({ name: `${defaultValues.user.name} ${defaultValues.user.firstSurname} ${defaultValues.user.secondSurname}`, value: defaultValues.userId });
  }, []);

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data, noControl);
  };

  // Para el search select
  const getUsuarios = (page, findName) => {
    let settings = {
      // TODO
      url: getUrl(page, findName),
      method: "GET",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Manejador de la respuesta de gestUsuarios
  const handleGetUsuarios = (page = 1, findName = "", addMore = false) => {
    return getUsuarios(page, findName)
      .then((response) => {
        addMore ? setUsuarios([...usuarios, ...processUsuarios(response.items)]) : setUsuarios(processUsuarios(response.items));
        return response;
      })
      .catch(() => {});
  };

  // Procesamiento de la función que obtiene los usuarios
  const processUsuarios = (usuarios) => {
    return usuarios.map((miUsuario) => {
      let nuevoUsuario = {};
      if (cargosContext[type]["usuario"].toLowerCase() === "hermana") {
        nuevoUsuario.component = (
          <CardUsuario
            title={<small>{`${miUsuario.name} ${miUsuario.firstSurname} ${miUsuario.secondSurname}`}</small>}
            heightPhoto={"4rem"}
            cardImage={miUsuario.photo ? `${process.env.REACT_APP_API_URL}/download/usuarios/${miUsuario.id}` : "/images/nun.png"}
            imgOnError={"/images/nun.png"}
          />
        );
      }
      if (cargosContext[type]["usuario"].toLowerCase() === "usuario") {
        let defaultImage = "/images/nun.png";
        if (miUsuario.type === "Laico") defaultImage = miUsuario.gender === "h" ? "/images/laico1.png" : "/images/laico2.png";
        nuevoUsuario.component = (
          <CardUsuario
            title={<small>{`${miUsuario.name} ${miUsuario.firstSurname} ${miUsuario.secondSurname}`}</small>}
            heightPhoto={"4rem"}
            cardImage={miUsuario.photo ? `${process.env.REACT_APP_API_URL}/download/usuarios/${miUsuario.id}` : defaultImage}
            imgOnError={defaultImage}
          />
        );
      }
      nuevoUsuario.name = `${miUsuario.name} ${miUsuario.firstSurname} ${miUsuario.secondSurname}`;
      nuevoUsuario.value = miUsuario.id;
      return nuevoUsuario;
    });
  };

  // Obtiene la url para pedir usuarios
  const getUrl = (page, findName) => {
    switch (type) {
      // Provinciales
      case "gobiernoProvincial":
      case "oficiosProvinciales":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&provincia=${idEntidad}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}&allUser=true`;
        break;
      case "otrosServiciosProvinciales":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&provincia=${idEntidad}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&findName=${findName}&allUser=true`;
        break;
      // Generales
      case "gobiernoGeneral":
      case "oficiosGenerales":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}&allUser=true`;
        break;
      case "otrosServiciosGenerales":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&findName=${findName}&allUser=true`;
        break;
      // Representantes legales
      case "rlProvincial":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&provincia=${idEntidad}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}&allUser=true`;
        break;
      case "rlGeneral":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}&allUser=true`;
        break;
      case "rlObra":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&provincia=${idEntidad}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&findName=${findName}&allUser=true`;
        break;
      // Comunitarios
      case "serviciosComunitarios":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&comunidad=${idSubEntidad}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}&allUser=true`;
        break;
      // Equipos
      case "equiposComisiones":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&provincia=${idEntidad}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&findName=${findName}&allUser=true`;
        break;
      // Misiones
      case "equiposDirectivosEducativo":
      case "equiposDirectivosAlojamiento":
      case "equiposDirectivosSalud":
      case "equiposDirectivosEspiritualidad":
      case "equiposDirectivosSocial":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&provincia=${idEntidad}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&findName=${findName}&allUser=true`;
        break;
      case "hermanasQueTrabajanObraOProyecto":
        if (!noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&provincia=${idEntidad}&findName=${findName}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?page=${page}&findName=${findName}&allUser=true`;
        break;
      default:
        return "";
    }
  };

  // Obtiene el mensaje para el tooltip del buscador
  const getToolTipMessage = () => {
    switch (type) {
      // Provincias
      case "gobiernoProvincial":
      case "oficiosProvinciales":
        if (!noControl) return `Busque y seleccione entre todas las hermanas de la provincia`;
        if (noControl) return `Busque y seleccione entre todas las hermanas del sistema`;
        break;
      case "otrosServiciosProvinciales":
        if (!noControl) return `Busque y seleccione entre todas las hermanas de la provincia y todos los laicos del sistema`;
        if (noControl) return `Busque y seleccione entre todos los usuarios del sistema`;
        break;
      // Dirección general
      case "gobiernoGeneral":
      case "oficiosGenerales":
        return `Busque y seleccione entre todas las hermanas del sistema`;
      case "otrosServiciosGenerales":
        return `Busque y seleccione entre todos los usuarios del sistema`;
      // Representantes legales
      case "lProvincial":
        if (!noControl) return `Busque y seleccione entre todas las hermanas de la provincia`;
        if (noControl) return `Busque y seleccione entre todas las hermanas del sistema`;
        break;
      case "rlGeneral":
        return `Busque y seleccione entre todas las hermanas del sistema`;
      case "rlObra":
        return `Busque y seleccione entre todas las hermanas de la provincia y todos los laicos del sistema`;
      // Comunidades
      case "serviciosComunitarios":
        if (!noControl) return `Busque y seleccione entre todas las hermanas de la comunidad`;
        if (noControl) return `Busque y seleccione entre todas las hermanas del sistema`;
        break;
      // Equipos
      case "equiposComisiones":
        if (!noControl) return `Busque y seleccione entre todas las hermanas de la provincia y todos los laicos del sistema`;
        if (noControl) return `Busque y seleccione entre todos los usuarios del sistema`;
        break;
      // Misiones
      case "equiposDirectivosEducativo":
      case "equiposDirectivosAlojamiento":
      case "equiposDirectivosSalud":
      case "equiposDirectivosEspiritualidad":
      case "equiposDirectivosSocial":
        if (!noControl) return `Busque y seleccione entre todas las hermanas de la provincia y todos los laicos del sistema`;
        if (noControl) return `Busque y seleccione entre todos los usuarios del sistema`;
        break;
      default:
        return "";
    }
  };

  // Validación para la fecha de fin puede que sea required o no
  const isEndDateRequired = () => {
    switch (type) {
      // Provincial y general
      case "otrosServiciosProvinciales":
      case "otrosServiciosGenerales":
        return false;
      // Representantes legales
      case "rlProvincial":
      case "rlGeneral":
      case "rlObra":
        return false;
      // Comunidades
      case "serviciosComunitarios":
        return false;
      // Equipos
      case "equiposComisiones":
        return false;
      // Misiones
      case "equiposDirectivosEducativo":
      case "equiposDirectivosAlojamiento":
      case "equiposDirectivosSalud":
      case "equiposDirectivosEspiritualidad":
      case "equiposDirectivosSocial":
        return false;
      default:
        return true;
    }
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      {noControl && (
        <Alert variant="danger" title="cuidado">
          <Alert.Heading>
            <b>¡Cuidado!</b>
          </Alert.Heading>
          Está accediendo a una parte del sistema donde no hay restricciones en la insercción de datos. Las acciones que se lleven a cabo estarán bajo su responsabilidad.
        </Alert>
      )}

      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="usuario-añadir-cargo">
          <Form.Label className="d-flex">
            {cargosContext[type]["usuario"]} *
            <TooltipIcon className="pl-2" content={getToolTipMessage()} />
          </Form.Label>

          <SearchSelectObserver
            options={usuarios}
            name={"userId"}
            reactHookFormsRef={register("userId", {
              required: "Este campo es obligatorio",
            })}
            requestMoreOptions={handleGetUsuarios}
            methods={methods}
            defaultValue={defaultUsuario}
            ErrorMessage={ErrorMessage}
          />
        </Form.Group>
      </Form.Row>
      {/* Sino es representante legal mostramos el input de cargos */}
      {cargosContext[type]["cargos"] !== "rl" && (
        <Form.Row>
          <Form.Group as={Col} xs={12} md controlId="tipo-cargo">
            <Form.Label>{`${cargosContext[type]["cargoServicio"]}`} *</Form.Label>
            <Form.Control
              name="cargo"
              as="select"
              disabled={estamosEditando}
              custom
              isInvalid={errors.cargo}
              {...register("cargo", {
                required: "Este campo es obligatorio",
                validate: async (cargo) => {
                  if (!noControl) return (await cargoDisponible(cargo, [defaultValues?.cargo, "Miembro"])) || `${cargosContext[type]["cargoServicio"]} no disponible`;
                },
              })}
            >
              {cargosContext[type]["cargos"]
                ? Object.keys(cargosContext[type]["cargos"]).map((cargoKey, index) => (
                    <option key={index} value={cargoKey}>
                      {cargosContext[type]["cargos"][cargoKey]}
                    </option>
                  ))
                : ""}
            </Form.Control>
            <ErrorMessage errors={errors} name="cargo" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
          </Form.Group>
        </Form.Row>
      )}
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="activity-start-mission">
          <Form.Label>{"Fecha de inicio"} *</Form.Label>

          <Form.Control
            name="startDate"
            type="date"
            disabled={estamosEditando}
            isInvalid={errors?.startDate}
            {...register("startDate", {
              required: "Este campo es obligatorio",
              validate: {
                // dateMayorQueHoy: (date) => {
                //   let today = new Date();
                //   if (!noControl) return new Date(today.getFullYear(), today.getMonth(), today.getDate()) <= new Date(date) ? true : "La fecha debe ser mayor o igual a hoy";
                // },
                dateMenorQueEndDate: (date) => {
                  if (watch("endDate")) return new Date(watch("endDate")) > new Date(date) ? true : "La fecha de inicio debe ser menor o a la fecha de fin";
                },
              },
            })}
            // Para controlar que al añadir cada vez que se cambia el valor del startdate se cambie el valor del endDate
            onChange={(e) => {
              // Si no estamos editando y estamos en servicios de provincia o direccion general
              if (!estamosEditando && handlerEndDate()) setValue("endDate", dateToString2(addYears(new Date(e.target.value), handlerEndDate())));
            }}
          />
          <ErrorMessage errors={errors} name="startDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>

        <Form.Group as={Col} xs={12} md controlId="activity-end-mission">
          <Form.Label className="d-flex">
            {"Fecha de fin *"} {isEndDateRequired() && "*"}
            {!estamosEditando && handlerEndDate() && <TooltipIcon className="pl-2" content={"La fecha de fin se establecerá por defecto a 3 años vista."} />}
          </Form.Label>
          <Form.Control
            name="endDate"
            type="date"
            isInvalid={errors?.endDate}
            {...register("endDate", {
              validate: {
                correctDate: (date) => {
                  if (!noControl && date && !estamosEditando) return new Date(date) <= new Date(watch("startDate")) ? "La fecha no debe ser mayor a la fecha de inicio" : true;
                },
                isEndDateRequired: (date) => {
                  if (isEndDateRequired() && !date) return "Este campo es obligatorio";
                },
              },
            })}
          />
          <ErrorMessage errors={errors} name="endDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
      </Form.Row>

      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormCargo;
